export default __webpack_public_path__ + "static/2312-6a8d8a9f1ed2669969851fb87f1a9f74.gif";